import { Col, Row } from "react-bootstrap";
import { Link, useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import axios from "axios";
const MovieDetails = () => {
  const param = useParams();
  const [movie, setMovie] = useState([]);
  // get movie details from the API
  useEffect(() => {
    const controller = new AbortController();
    const getMovieDetails = async () => {
      let res = await axios.get(
        `https://api.themoviedb.org/3/movie/${param.id}?api_key=f322ddbfea3ab9b5fac98fda3edb0056&language=ar`,
        { signal: controller.signal }
      );
      setMovie(res.data);
    };
    getMovieDetails();
    return () => {
      controller.abort();
    };
  }, [param.id]);
  return (
    <>
      <Row
        className="mt-4 p-2"
        style={{ backgroundColor: "#f6f3f3d0", borderRadius: "20px" }}
      >
        <Col lg={4} md={4} sm={12}>
          <img
            src={`https://image.tmdb.org/t/p/w500/${movie.poster_path}`}
            style={{ width: "100%", borderRadius: "10px" }}
            alt="Alternate"
          />
        </Col>
        <Col
          lg={8}
          md={8}
          sm={12}
          className="d-flex align-items-center mt-4 mt-md-0 justify-content-center"
        >
          <div className="text-center">
            <h3>اسم الفيلم: {movie.original_title}</h3>
            <h3>تاريخ الفيلم : {movie.release_date}</h3>
            <h3>عدد المقيمين : {movie.vote_count}</h3>
            <h3>التقييم : {movie.vote_average}</h3>
          </div>
        </Col>
      </Row>
      <Row
        className="my-3 p-2"
        style={{ backgroundColor: "#f6f3f3d0", borderRadius: "20px" }}
      >
        <Col className="text-end">
          <h3>القصة:</h3>
          <br />
          <p>{movie.overview}</p>
        </Col>
      </Row>
      <Row className="mt-5 border mb-2 d-flex flex-column gap-3 flex-sm-row align-items-center">
        <Col
          style={{ display: "flex" }}
          className="justify-content-center  justify-content-sm-end"
        >
          <Link to="/">
            <button
              style={{ backgroundColor: "#b45b35", color: "white" }}
              className="p-2 border-0"
            >
              عودة للرئيسية
            </button>
          </Link>
        </Col>
        <Col className="d-flex justify-content-center justify-content-sm-start">
          <a href={movie.homepage}>
            <button
              style={{ backgroundColor: "#b45b35", color: "white" }}
              className="p-2 border-0"
            >
              مشاهدة الفيلم
            </button>
          </a>
        </Col>
      </Row>
    </>
  );
};

export default MovieDetails;
